import { FC } from 'react';
import { Box, Card, Checkbox, Collapse, SimpleGrid, TextInput, Title } from '@mantine/core';
import { ShippingData, UserData } from './ProductTypeForm';
import { useDisclosure } from '@mantine/hooks';

interface Props {
	userDataForm: UserData;
	handleUserDataChange: (
		key: keyof UserData,
		value: UserData[keyof UserData]
	) => void;
	shippingDataForm: ShippingData;
	handleShippingDataChange: (
		key: keyof ShippingData,
		value: ShippingData[keyof ShippingData]
	) => void;
}

export const StepClient: FC<Props> = ({
	userDataForm,
	handleUserDataChange,
	shippingDataForm,
	handleShippingDataChange,
}) => {
	const [showInvoiceData, invoideControls] = useDisclosure(
		!!userDataForm.companyName
	);

	return (
		<Box style={{ flexGrow: 1 }}>
			<Title order={2} c="black" mb="sm">
				Formularz oferty - dane do zamówienia
			</Title>
			<Card>
				<Title order={3} c="black" mb="md">
					Dane podstawowe
				</Title>
				<SimpleGrid cols={{ base: 1, sm: 2 }}>
					<TextInput
						required
						label="Imię"
						placeholder="Wpisz Imię"
						value={userDataForm.name}
						onChange={({ target }) =>
							handleUserDataChange('name', target.value)
						}
					/>
					<TextInput
						required
						label="Nazwisko"
						placeholder="Wpisz nazwisko"
						value={userDataForm.surname}
						onChange={({ target }) =>
							handleUserDataChange('surname', target.value)
						}
					/>
					<TextInput
						required
						type="email"
						label="Adres e-mail"
						placeholder="Wpisz adres e-mail"
						value={userDataForm.email}
						onChange={({ target }) =>
							handleUserDataChange('email', target.value)
						}
					/>
					<TextInput
						required
						type="tel"
						label="Numer telefonu"
						placeholder="Wpisz nr telefonu"
						value={userDataForm.phone}
						onChange={({ target }) =>
							handleUserDataChange('phone', target.value)
						}
					/>
				</SimpleGrid>
				<Checkbox
					my="lg"
					label="Chcę podać dane do faktury"
					checked={showInvoiceData}
					onChange={invoideControls.toggle}
				/>
				<Collapse in={showInvoiceData}>
					<Title order={3} c="black" mb="md">
						Dane do faktury
					</Title>
					<SimpleGrid cols={{ base: 1, sm: 2 }} mb="lg">
						<TextInput
							label="Nazwa firmy"
							placeholder="Wpisz nazwę firmy"
							value={userDataForm.companyName}
							onChange={({ target }) =>
								handleUserDataChange('companyName', target.value)
							}
						/>
						<TextInput
							label="NIP"
							placeholder="Wpisz NIP"
							value={userDataForm.NIP}
							onChange={({ target }) =>
								handleUserDataChange('NIP', target.value)
							}
						/>
						<TextInput
							label="Miasto"
							placeholder="Wpisz miasto"
							value={userDataForm.city}
							onChange={({ target }) =>
								handleUserDataChange('city', target.value)
							}
						/>
						<TextInput
							label="Kod pocztowy"
							placeholder="Wpisz kod pocztowy"
							value={userDataForm.postalCode}
							onChange={({ target }) =>
								handleUserDataChange('postalCode', target.value)
							}
						/>
						<TextInput
							label="Ulica i numer"
							placeholder="Wpisz ulicę i numer"
							value={userDataForm.address}
							onChange={({ target }) =>
								handleUserDataChange('address', target.value)
							}
						/>
					</SimpleGrid>
				</Collapse>
				<Title order={3} c="black" mb="md">
					Dane do dostawy
				</Title>
				<SimpleGrid cols={{ base: 1, sm: 2 }}>
					<TextInput
						required
						label="Miasto"
						placeholder="Wpisz miaso"
						value={shippingDataForm.city}
						onChange={({ target }) =>
							handleShippingDataChange('city', target.value)
						}
					/>
					<TextInput
						required
						label="Kod pocztowy"
						placeholder="Wpisz kod pocztowy"
						value={shippingDataForm.postalCode}
						onChange={({ target }) =>
							handleShippingDataChange('postalCode', target.value)
						}
					/>
					<TextInput
						required
						label="Ulica i numer"
						placeholder="Wpisz ulicę i numer"
						value={shippingDataForm.address}
						onChange={({ target }) =>
							handleShippingDataChange('address', target.value)
						}
					/>
				</SimpleGrid>
			</Card>
		</Box>
	);
};
